import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { DEFAULT_TEXT_ALIGN, DEFAULT_TEXT_BOLD, DEFAULT_TEXT_IS_CHILDREN, DEFAULT_TEXT_SIZE, DEFAULT_TEXT_UPPERCASE } from './Text.constants';
import { TextRoot } from './Text.styled';
// Component.
// -----------------------------------------------------------------------------
export const Text = forwardRef(({ align = DEFAULT_TEXT_ALIGN, bold = DEFAULT_TEXT_BOLD, children, isTitle = DEFAULT_TEXT_IS_CHILDREN, size = DEFAULT_TEXT_SIZE, uppercase = DEFAULT_TEXT_UPPERCASE, ...rest }, ref) => (_jsx(TextRoot, { align: align, bold: bold, ref: ref, isTitle: isTitle, size: size, uppercase: uppercase, ...rest, children: children })));
// Component configuration.
// -----------------------------------------------------------------------------
Text.displayName = 'Text';
export default Text;
//# sourceMappingURL=Text.js.map